export const sortStencils = (stencils) => {
    /**
     * TODO:
     * sort stencils by their stencil ID
     * - tokenize stencil ID to compare their strings
     */
    return stencils.sort((a, b) => {
        // tokenize ID strings
        const tokensA = a.id.split('-');
        const tokensB = b.id.split('-');

        let maxLength = Math.max(tokensA.length, tokensB.length);

        // compare each token:
        for (let i = 0; i < maxLength; i++) {
            var tokenA = tokensA[i] || '';
            var tokenB = tokensB[i] || '';

            // compare tokens as integers:
            var numA = parseInt(tokenA, 10);
            var numB = parseInt(tokenB, 10);

            var isNumA = !isNaN(numA);
            var isNumB = !isNaN(numB);

            if (isNumA && isNumB) {
                if (numA !== numB) return numA - numB;
            }
            else {
                const cmp = tokenA.localeCompare(tokenB);
                if (cmp !== 0) return cmp;
            }
        }

        // same ID
        return 0;
    });
};